<template>
  <div>
    <div v-if="!this.$store.getters.isLoading">
      <StripeElements
        ref="elementsRef"
        :pk="publishableKey"
        :amount="theAmount"
        :client-secret="theClientSecret"
        @loading="loading"
        @element="checkElementLoading"
        @payment="paymentStatus"
      >
      </StripeElements>
      <button :disabled="checkDisabled" class="btn btn-primary mb-2" @click="checkout">{{ $t('payment.payNow') }} {{theAmount + this.$store.getters.authenticationData.currency.currencySign}}</button>
    </div>
  </div>
</template>

<script>
import StripeElements from '@/components/payment/StripeCheckout/Elements.vue'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'CardPayment',
  components: { StripeElements },
  mixins: [errorHandlerMixin],
  data () {
    return {
      elementLoading: true,
      theLoad: null,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      card: null,
      theAmount: 0,
      theClientSecret: null,
      amountValidation: null,
    }
  },
  props: {
    amount: Number,
    clientSecret: String,
  },
  methods: {
    loading (state) {
      this.setLoad(state)
    },
    setLoad (state) {
      this.theLoad = state
    },
    checkElementLoading (state) {
      this.elementLoading = state
    },
    checkout () {
      if (!this.theAmount) {
        this.amountValidation = this.translation.screens.payment.validateAmount
        return
      }
      this.theLoad = true
      this.amountValidation = null
      this.$refs.elementsRef.submit()
    },
    paymentStatus (state, resp) {
      this.$emit('payment', state, resp)
    },
  },
  computed: {
    checkDisabled () {
      return this.theLoad
    },
  },
  mounted () {
    this.theAmount = this.amount
    this.theClientSecret = this.clientSecret
  },
}
</script>

<style scoped>
  .has-error {
    border: 1px solid red;
  }

  .has-error-txt {
    color: red;
  }

  button.btn-primary {
    display: inline-block;
    margin: 0.375rem 0.5rem;
    background-image: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: none !important;
    border: 0;
    font-family: "Source Sans Pro", sans-serif;
    text-decoration: none !important;
    text-transform: initial;
    font-weight: 700;
    cursor: pointer;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    padding: 0.375rem 1.25rem;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.032rem;
    background-color: rgb(108, 127, 238);
    color: rgb(255, 255, 255);
    border-radius: 0.2rem !important;
  }

  button[disabled] {
    background-color: #6c757d;
    border-color: #6c757d;
    color: #ffffff;
    cursor: not-allowed;
  }
</style>
